import { render, staticRenderFns } from "./MaterialsTreePage.vue?vue&type=template&id=408af50d&scoped=true"
import script from "./MaterialsTreePage.vue?vue&type=script&lang=js"
export * from "./MaterialsTreePage.vue?vue&type=script&lang=js"
import style0 from "./MaterialsTreePage.vue?vue&type=style&index=0&id=408af50d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "408af50d",
  null
  
)

export default component.exports